import type { RouteRecordRaw } from 'vue-router';
import { CompanyPermissionsCodename, PermissionsCodename } from 'src/api';
import { requireUserPermission } from 'src/router/guards/requireUserPermission';
import { requireCompanyPermission } from 'src/router/guards/requireCompanyPermission';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const calendarRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'calendar',
    redirect: { name: 'calendar-users' },
  },
  {
    path: 'physiotherapists',
    alias: $gettext('fyzioterapeuti'),
    name: 'calendar-users',
    props: true,
    component: () => import('pages/calendar/CalendarPage.vue'),
  },
  {
    path: 'rooms',
    alias: $gettext('mistnosti'),
    name: 'calendar-rooms',
    props: true,
    component: () => import('pages/calendar/CalendarRoomsPage.vue'),
  },
  {
    path: 'planning',
    alias: $gettext('planovani'),
    name: 'calendar-planning',
    props: true,
    component: () => import('pages/calendar/CalendarPlanningPage.vue'),
  },
  {
    path: 'room-planning',
    alias: $gettext('planovani-mistnosti'),
    name: 'calendar-room-planning',
    props: true,
    component: () => import('pages/calendar/RoomPlaningCalendarPage.vue'),
  },
];

// Kalendář → web `/calendar` (`/kalendar`). Web `calendar` is a redirect to
// calendar-users; in the mobile tree `calendar` is the single calendar page
// (no collision — the trees never coexist in one build).
export const mobileCalendarRoutes: RouteRecordRaw[] = [
  {
    path: 'calendar',
    alias: $gettext('kalendar'),
    name: 'calendar',
    meta: { bottomNav: true },
    beforeEnter: [
      requireUserPermission(PermissionsCodename.VIEW_CALENDAR_TAB),
      requireCompanyPermission(CompanyPermissionsCodename.ALLOW_CALENDAR),
    ],
    component: () => import('pages/mobile/MobileCalendarPage.vue'),
  },
];
